if($('.careers-accordion').length > 0 && $('#input_2_8').length > 0) {

    $('.careers-accordion .accordion-panel').each(function() {
        let panel = $(this),
            heading = $('#' + panel.attr('aria-labelledby')),
            headingText = heading.find('.accordion-title').text(),
            body = panel.find(' > div');

        body.append('<a href="#" class="btn btn-orange apply-button" style="margin-top: 20px;" data-career="' + headingText + '">Apply Now</a>');
    });

    $(document).on('click', '.careers-accordion .apply-button', function(e) {
        e.preventDefault();
        let career = $(this).data('career');
        $('#input_2_8').val(career);
        $('html, body').animate({
            scrollTop: $('#gform_2').offset().top - 150
        }, 500);
    });

}
